module.exports = __webpack_public_path__ + "static/features-allocate-a062d04539ebd01ebfef034be38ca3de.png";